import React from 'react';
import PageHero from './PageHero';
import './About.css';

const About = () => {
  return (
    <>
      <PageHero
        sectionId="about"
        title="About Rivontrix"
        subtitle="Who We Are"
        description="A next-generation technology and consulting firm combining AI-driven cybersecurity products, Generative AI solutions, and digital transformation with manpower expertise. We power enterprise with resilient, intelligent defense and adaptable talent ecosystems."
        image="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1600&q=80"
        gradient="linear-gradient(135deg, rgba(102, 126, 234, 0.9), rgba(118, 75, 162, 0.9))"
      />
      <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <div className="about-features">
              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-shield-virus"></i>
                </div>
                <h3>AI-Driven Defense</h3>
                <p>Advanced cybersecurity products powered by artificial intelligence to protect your digital infrastructure.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <h3>Digital Transformation</h3>
                <p>Strategic consulting services to help enterprises evolve and innovate in the digital landscape.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <i className="fas fa-users-cog"></i>
                </div>
                <h3>Talent Ecosystems</h3>
                <p>Adaptable workforce solutions connecting enterprises with world-class technology professionals.</p>
              </div>
            </div>
          </div>
          <div className="about-visual">
            <div className="stats-container">
              <div className="stat-item">
                <div className="stat-icon">
                  <i className="fas fa-rocket"></i>
                </div>
                <div className="stat-content">
                  <h3>Innovative</h3>
                  <p>Solutions Delivered</p>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <i className="fas fa-shield-alt"></i>
                </div>
                <div className="stat-content">
                  <h3>99.9%</h3>
                  <p>Security Uptime</p>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <i className="fas fa-users"></i>
                </div>
                <div className="stat-content">
                  <h3>Expert</h3>
                  <p>Team & Talent</p>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <i className="fas fa-globe"></i>
                </div>
                <div className="stat-content">
                  <h3>Global</h3>
                  <p>Reach & Expertise</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default About;

